/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type LoadValuesOptionExpenseType = (typeof LoadValuesOptionExpenseType)[keyof typeof LoadValuesOptionExpenseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LoadValuesOptionExpenseType = {
  life_insurance: "life_insurance",
  vehicle_insurance: "vehicle_insurance",
  accident_insurance: "accident_insurance",
  house_insurance: "house_insurance",
  other: "other",
} as const;
